import { MutationUpdaterFn } from '@apollo/client'
import {
  GqlCreateNewsCommentMutation,
  NewsItemFooter_NewsItemFragment,
  NewsItemFooter_NewsItemFragmentDoc,
} from 'generated/graphql'

const createNewsCommentUpdater =
  (newsItemId: string): MutationUpdaterFn<GqlCreateNewsCommentMutation> =>
  (cache, { data }) => {
    if (!data?.createNewsComment?.newsComment) {
      return
    }
    const targetFragmentOptions = {
      id: `NewsItem:${newsItemId}`,
      fragment: NewsItemFooter_NewsItemFragmentDoc,
      fragmentName: 'NewsItemFooter_NewsItem',
    }

    const cachedNewsItem = cache.readFragment<NewsItemFooter_NewsItemFragment>({
      ...targetFragmentOptions,
    })

    if (cachedNewsItem) {
      cache.writeFragment<NewsItemFooter_NewsItemFragment>({
        ...targetFragmentOptions,
        data: {
          ...cachedNewsItem,
          newsCommentCount: cachedNewsItem.newsCommentCount + 1,
        },
      })
    }
  }

export default createNewsCommentUpdater
